import { Controller } from "@hotwired/stimulus";

// Seleccion en lote de la tabla de Transacciones. Sin esto hay que tildar cincuenta
// casillas a mano, que es justo lo que el boton viene a evitar.
//
// El contador y el deshabilitado no son cosmetica: el boton dice "conciliar" y no hay
// confirmacion, asi que antes de apretarlo tiene que estar a la vista cuantas filas
// se van a marcar.
export default class extends Controller {
  static targets = ["casilla", "todas", "contador", "boton"];

  connect() {
    this.actualizar();
  }

  alternarTodas() {
    this.casillaTargets.forEach((c) => {
      c.checked = this.todasTarget.checked;
    });
    this.actualizar();
  }

  actualizar() {
    const n = this.casillaTargets.filter((c) => c.checked).length;

    this.contadorTargets.forEach((e) => {
      e.textContent = n ? ` (${n})` : "";
    });
    this.botonTargets.forEach((b) => {
      b.disabled = n === 0;
    });

    if (this.hasTodasTarget) {
      this.todasTarget.checked = n > 0 && n === this.casillaTargets.length;
      // Estado intermedio: algunas si, otras no. Sin esto la casilla del encabezado
      // se ve vacia con 49 de 50 tildadas.
      this.todasTarget.indeterminate = n > 0 && n < this.casillaTargets.length;
    }
  }
}
